module.exports = __webpack_public_path__ + "static/media/default_img.2f78bb78.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/default_img.png
// module id = 497
// module chunks = 0